module.exports = __webpack_public_path__ + "img/adminlogo-dark.3748fd72.png";